<ng-container *transloco="let t">
  <div fxFill class="setpassword-main" fxLayout="column" fxLayoutAlign="center center">
    <div class="setpassword-card">
      <div class="logo">
        <img src="/assets/images/{{
              (layoutQuery.direction$ | async) == 'rtl'
                ? 'login-logo-ar'
                : 'login-logo'
            }}.png" />
      </div>
      <h2 fxLayout fxLayoutAlign="start center" fxLayoutGap="5px" class="form-title">
        <span style="color: white;">{{
          forgotpass
          ? t("setPassword.ResettingPassword")
          : t("setPassword.SetPassword")
          }}</span>
        <mat-icon matTooltipClass="amghara-tooltip" style="color: white;"
          matTooltip="{{ t('setPassword.PasswordComplexity') }}">help</mat-icon>
      </h2>

      <form [formGroup]="profileForm" *ngIf="profileForm" (ngSubmit)="update()">
        <div *ngIf="showError" class="warning-info" style="color: red;">
          {{ t("setPassword.InvalidDetails") }}
        </div>
        <mat-form-field style="padding-bottom: 10px;">
          <mat-label>{{ t("setPassword.Password") }}</mat-label>
          <input matInput type="password" formControlName="password" autocomplete="off" />
          <mat-error style="color: red;" *ngIf="
                validate('password')?.invalid &&
                validate('password')?.errors?.['required'] &&
                (validate('password')?.dirty || validate('password')?.touched)
              ">
            {{ t("Thisisrequired") }}
          </mat-error>
          <mat-error style="color: red;" *ngIf="
                validate('password')?.invalid &&
                validate('password')?.errors?.['pattern']
              ">
            {{ t("setPassword.InvalidPassword") }}
          </mat-error>
        </mat-form-field>
        <mat-form-field style="padding-bottom: 18px;">
          <mat-label>{{ t("setPassword.ConfirmPassword") }}</mat-label>
          <input matInput type="password" formControlName="confirmPassword" autocomplete="off" />
          <mat-error style="color: red;" *ngIf="
                validate('confirmPassword')?.invalid &&
            validate('confirmPassword')?.errors?.['required'] &&
                (validate('confirmPassword')?.dirty ||
                  validate('confirmPassword')?.touched)
              ">
            {{ t("Thisisrequired") }}
          </mat-error>
          <mat-error style="color: red;" *ngIf="validate('confirmPassword')?.invalid && validate('confirmPassword')?.hasError('mismatch')">
            {{ t("setPassword.InvalidConfirmPassword") }}
          </mat-error>
        </mat-form-field>
        <div fxLayout="column" class="form-button">
          <button *ngIf="!showSpinner" [disabled]="profileForm.invalid" type="submit" mat-flat-button color="primary" class="verify-button">
            {{ t("setPassword.Save") }}
          </button>
          <button *ngIf="showSpinner" mat-flat-button color="primary" class="spinner-button">
            <mat-spinner diameter="20" class="mat-spinner-white"></mat-spinner>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>